export default function SubSectionLabel({ label, className }) {
  return (
    <div className={`${className || ''} font-medium text-[22px]`}>
      {label}
    </div>
  );
}
